<template>
  <div class="js-response">
    <div class="d-flex justify-end"></div>
    <div class="js-response-question">{{ response.key }}</div>
    <div v-if="response.options.type === 'SelectOne'">
      <v-radio-group :value="response.value" @change="saveSelectOne">
        <div v-for="choice in response.options.choices">
          <v-radio :label="choice" :value="choice"></v-radio>
        </div>
      </v-radio-group>
    </div>
    <div v-else-if="response.options.type === 'SelectMany'">
      <div v-for="choice in response.options.choices">
        <v-checkbox
          id="js-select-many-response"
          :multiple="true"
          v-model="selectMany"
          :value="choice"
          :label="choice"
          @change="saveSelectMany"
          >{{ response.key }}</v-checkbox
        >
      </div>
    </div>
    <div v-else>
      <v-text-field
        id="js-free-text-response"
        :value="response.value"
        label="Answer"
        @blur="saveFreeText"
        :rules="longTextFieldRules"
      ></v-text-field>
    </div>
  </div>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"
import validationMixin from "@/mixins/validationMixin"
export default {
  mixins: [eventMixin, validationMixin],
  props: {
    response: { type: Object }
  },
  data: function() {
    return {
      selectMany: []
    }
  },
  created() {
    if (
      this.response.options.type === "SelectMany" &&
      Array.isArray(this.response.value)
    ) {
      this.selectMany = this.response.value.slice(0)
    }
  },
  methods: {
    saveSelectOne(e) {
      let model = Object.assign({}, JSON.parse(JSON.stringify(this.response)))
      model.value = e
      this.fireEvent("learningResponse:save", model)
    },
    saveSelectMany(e) {
      let model = Object.assign({}, JSON.parse(JSON.stringify(this.response)))
      model.value = this.selectMany
      this.fireEvent("learningResponse:save", model)
    },
    saveFreeText(e) {
      let model = Object.assign({}, this.response)
      model.value = e.target.value
      this.fireEvent("learningResponse:save", model)
    }
  }
}
</script>
